import React from 'react';
import { Divider, Table } from 'semantic-ui-react';
import { AsistenciaDelAlumnoDTO } from './tipos';

type TablaDeAsistenciasDelBloqueProps = {
    plan: keyof typeof nombreDelBloqueSegunPlan;
    porBloque: AsistenciaDelAlumnoDTO['porBloque'];
    bloques: readonly string[];
};

const nombreDelBloqueSegunPlan = {
    'anual': 'A',
    'intensivo': 'I',
    'intensivo-vespertino': 'V',
    'electivo': 'E',
};

// El orden se determina según el índice en este arreglo.
// El resultado es el record del bloque al índice.
const ordenDeBloques = [
    'LA1',
    'LA2',
    'LI1',
    'LI2',
    'LV1',
    'LV2',
    'MA1',
    'MA2',
    'MI1',
    'MI2',
    'MV1',
    'MV2',
    'HA1',
    'HA2',
    'HI1',
    'HI2',
    'HV1',
    'HV2',
    'BA',
    'QA',
    'FA',
    'BI',
    'QI',
    'FI',
    'BV',
    'QV',
    'FV',
    'BE',
    'QE',
    'FE',
].reduce<Record<string, number>>((rec, cod, idx) => {
    rec[cod] = idx;
    return rec;
}, {});

export const TablaDeAsistenciasDelBloque = (props: TablaDeAsistenciasDelBloqueProps) => {
    const { plan, porBloque, bloques } = props;

    const codigosDeBloques = bloques
        .map(nombreBloque => nombreBloque.split('-')[0])
        .filter(nombreBloque => nombreDelBloqueSegunPlan[plan] === nombreBloque[1])
        .sort((a, b) => (ordenDeBloques[a] ?? 100) - (ordenDeBloques[b] ?? 100));

    if (codigosDeBloques.length === 0) return null;
    if (codigosDeBloques.every(b => (porBloque[b] ? porBloque[b].length === 0 : true))) return null;

    return (
        <>
            <TablaDeAsistencias porBloque={porBloque} codigosDeBloques={codigosDeBloques} />
            <Divider hidden />
        </>
    );
};

interface TablaDeAsistenciasProps {
    porBloque: AsistenciaDelAlumnoDTO['porBloque'];
    codigosDeBloques: readonly string[];
}

const TablaDeAsistencias = (props: TablaDeAsistenciasProps) => {
    const { codigosDeBloques, porBloque } = props;

    const numeroUltimaClase = Math.max(
        ...codigosDeBloques.reduce<number[]>(
            (acc, codigoDelBloque) =>
                acc.concat(porBloque[codigoDelBloque]?.map(clase => clase.numeroDeClase) ?? []),
            [],
        ),
    );
    const numerosDeClases = Array.from({ length: numeroUltimaClase }).map((_, i) => i + 1);

    return (
        <Table celled compact size='small' definition collapsing textAlign='center'>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell />
                    {numerosDeClases.map(i => (
                        <Table.HeaderCell key={i} content={i} />
                    ))}
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {codigosDeBloques.map(bloque => {
                    const clases = porBloque[bloque];

                    return (
                        <Table.Row key={bloque}>
                            <Table.Cell textAlign='left'>{bloque}</Table.Cell>

                            {numerosDeClases.map(num => {
                                const clase = clases?.find(c => c.numeroDeClase === num);
                                const valor = clase?.asistencias[0].valor ?? 'A';

                                return (
                                    <Table.Cell
                                        key={num}
                                        style={{
                                            color: valor === 'P' ? 'green' : 'red',
                                            fontWeight: valor === 'P' ? 'bold' : 'normal',
                                        }}
                                    >
                                        {valor}
                                    </Table.Cell>
                                );
                            })}
                        </Table.Row>
                    );
                })}
            </Table.Body>
        </Table>
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/AsistenciaDelAlumno/TablaDeAsistencias.tsx